import rootPath from "../routes-path";

export { RouteProps } from "../routes-path";

export const path = "/partneri";

export default rootPath + path;